import { render, staticRenderFns } from "./CaptchaSettings.vue?vue&type=template&id=53735fa4&scoped=true"
import script from "./CaptchaSettings.vue?vue&type=script&lang=js"
export * from "./CaptchaSettings.vue?vue&type=script&lang=js"
import style0 from "./CaptchaSettings.vue?vue&type=style&index=0&id=53735fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53735fa4",
  null
  
)

export default component.exports